import * as React from 'react';
import { Product } from '~/Api/Product';
import { CzMaxPrice } from '~/Api/User/ProductGroup/CzMaxPrice';

export const ProductProvider: React.FunctionComponent<
	React.PropsWithChildren<{
		czMaxPrice: CzMaxPrice | null;
		id: string;
		children(product: Product | null): React.ReactNode;
	}>
> = ({ czMaxPrice, id, children }) => {
	const product = React.useMemo(
		() => czMaxPrice?.products.find((candidate) => candidate.product.id === id)?.product ?? null,
		[czMaxPrice, id]
	);
	return <>{children(product)}</>;
};

ProductProvider.displayName = 'CzMaxPrice.ProductProvider';
